import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const LoadingComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="nostra__icon nostra__icon__loading"
      width={size}
      height={size}
    >
      <circle fill={colorVar} stroke={colorVar} strokeWidth="1" r="2" cx="6" cy="8">
        <animate
          attributeName="cy"
          calcMode="spline"
          dur="2"
          values="8;24;8;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.4"
        ></animate>
      </circle>
      <circle fill={colorVar} stroke={colorVar} strokeWidth="1" r="2" cx="16" cy="8">
        <animate
          attributeName="cy"
          calcMode="spline"
          dur="2"
          values="8;24;8;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.2"
        ></animate>
      </circle>
      <circle fill={colorVar} stroke={colorVar} strokeWidth="1" r="2" cx="26" cy="8">
        <animate
          attributeName="cy"
          calcMode="spline"
          dur="2"
          values="8;24;8;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="0"
        ></animate>
      </circle>
    </svg>
  );
};

export const Loading = withIcon(LoadingComponent);
